import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { TravelRequestView } from '@/module/Travel/Request/TravelRequestView';
import { getTravelRequestOptions } from '@/module/Travel/Request/model/TravelRequestQuery';

export const Route = createFileRoute('/_auth/travel/_travel/requests/$requestId/_layout/')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.view' },
  },
});

function RouteComponent() {
  const { requestId } = Route.useParams();
  const { data: request } = useSuspenseQuery(getTravelRequestOptions(requestId));

  return <TravelRequestView request={request} />;
}
